import type { CsvEntityConfig } from '../types';

export function generateCsvTemplate(config: CsvEntityConfig): string {
  const headers = config.columns.map(c => c.key).join(',');
  const exampleLines = config.exampleRows.map(row =>
    config.columns.map(c => {
      const val = row[c.key] || '';
      return val.includes(',') ? `"${val}"` : val;
    }).join(',')
  );
  return [headers, ...exampleLines].join('\n');
}

export function downloadCsvTemplate(config: CsvEntityConfig) {
  const csv = generateCsvTemplate(config);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${config.entityName.toLowerCase().replace(/\s+/g, '-')}-template.csv`;
  link.click();
  URL.revokeObjectURL(url);
}



